__turbopack_context__.v({
  "header": "_5yit3W_header",
  "hero": "_5yit3W_hero",
  "subtitle": "_5yit3W_subtitle",
});
